<main class="dialog-body">
  <div class="dialog-header">
    <div class="dialog-header-text">Submit work experience</div>
    <div class="cross-icon" (click)="onCancel()">
      <img src="assets/images/cross-icon.svg" class="cross-icon-img" />
    </div>
  </div>

  <mat-dialog-content class="dialog-content">
    <div class="form-group-container d-grid gap-14" [formGroup]="form">
      <div>
        <app-input
          context="Normal"
          label="Event name"
          placeholder="Enter your event name"
          type="text"
          [required]="true"
          [control]="form.get('eventName')"
          [customErrorMessages]="{ required: 'Please enter a event name.' }"
        >
        </app-input>
        <!-- <app-input
          context="Normal"
          label="Status"
          placeholder="Select your status"
          type="select"
          [required]="true"
          [control]="form.get('eventStatus')"
          [options]="statusOption"
          [customErrorMessages]="{ required: 'Please select a status.' }"
        >
        </app-input> -->
      </div>

      <div class="d-grid gap-3">
        <div>
          <!-- <div class="d-flex justify-content-between">
                        <div class="Normal-label">Start & end date <span class="req-star">*</span></div>
                        <div class="Normal-label">No.of days</div>
                    </div> -->
          <div class="event-date-container">
            <div class="form-group">
              <app-input
                context="Normal"
                label=""
                placeholder="From"
                type="date"
                label="Start date"
                [control]="form.get('fromDate')"
                (dateChange)="calculateDays()"
                [required]="true"
                [customErrorMessages]="{
                  required: 'Please enter a start date',
                }"
                [disableWeekends]="true"
                (change)="calculateDays()"
              >
              </app-input>
            </div>
            <div class="form-group">
              <app-input
                context="Normal"
                label=""
                placeholder="To"
                type="date"
                [required]="true"
                label="End date"
                [control]="form.get('toDate')"
                (dateChange)="calculateDays()"
                (change)="calculateDays()"
                [min]="getMinEndDate()"
                [disableWeekends]="true"
                [customErrorMessages]="{ required: 'Please enter an end date' }"
              >
              </app-input>
            </div>
            <div class="form-group">
              <app-input
                context="Normal"
                label=""
                placeholder="0"
                type="text"
                label="No.of days"
                [control]="form.get('noOfDays')"
                [customErrorMessages]="{
                  required: 'Number of days is required.',
                  whitespace: 'Number of days is required',
                }"
              >
              </app-input>
            </div>
          </div>
        </div>

        <div class="w-100">
          <div class="form-group">
            <app-input
              context="Normal"
              label=""
              placeholder="Select time"
              type="time"
              [control]="form.get('eventTime')"
              label="Start & end time"
              [required]="true"
              [customErrorMessages]="{
                required: 'Please enter start and end time.',
                invalidFormat: 'Invalid time format. Use HH:mm format',
                timeRange: 'End time must be after start time',
              }"
            >
            </app-input>
          </div>
        </div>
      </div>
      <div class="form-group">
        <app-input
          context="Normal"
          label="Company / Employer"
          placeholder="Enter name of company or employer"
          type="text"
          [control]="form.get('employerName')"
          [required]="true"
          [customErrorMessages]="{
            required: 'Please enter a company or employer.',
            whitespace: 'Please enter a company or employer.',
          }"
        >
        </app-input>
      </div>

      <div class="form-group">
        <app-input
          context="Normal"
          label="Location"
          placeholder="Enter your location"
          type="text"
          [required]="true"
          [control]="form.get('location')"
          [customErrorMessages]="{
            required: 'Please enter a location.',
            whitespace: 'Please enter a location',
          }"
        >
        </app-input>
      </div>

      <div class="form-group">
        <app-input
          context="Normal"
          label="Type of work experience"
          placeholder="Select type of work experience"
          type="select"
          [required]="true"
          [control]="form.get('workExperinceType')"
          [options]="workExperinceTypeOption"
          [customErrorMessages]="{ required: 'Please select a type.' }"
        >
        </app-input>
      </div>

      <!-- <div class="w-100">
        <div class="Normal-label mb-2">
          Event description
        </div>

        <div class="note-container">
          <div>
            <textarea
              class="note-input"
              formControlName="eventDescription"
              (input)="autoResize($event)"
              placeholder="Enter your description"
            ></textarea>
          </div>
        </div>
      </div> -->

      <div class="w-100">
        <div class="Normal-label mb-2">
          Upload Evidence
          <span class="optional-text">(optional)</span>
        </div>

        <div class="file-upload-section">
          <div
            class="upload-area"
            [class.drag-over]="isDragOver"
            [ngClass]="
              fileControl.touched && fileControl.invalid
                ? 'upload-area-error'
                : ''
            "
            (click)="fileInput.click()"
            (dragover)="onDragOver($event)"
            (dragleave)="onDragLeave($event)"
            (drop)="onDrop($event)"
          >
            <input
              type="file"
              #fileInput
              (change)="onFileSelected($event)"
              accept=".pdf"
              hidden
              multiple
            />
            <img class="upload-icon" src="assets/images/image-add.svg" />
            <p class="upload-text">Drag & drop file or <span>browse</span></p>
            <p class="format-info">Supported formats: PDF.</p>
            <div
              class="uploaded-images-container"
              *ngIf="uploadedFiles.length > 0"
            >
              <div class="uploaded-images-header">Uploaded File</div>
              <div class="uploaded-images-grid">
                <div
                  class="uploaded-image-item"
                  *ngFor="let file of uploadedFiles; let i = index"
                >
                  <img
                    [src]="file.previewUrl"
                    class="image-preview"
                    *ngIf="file.type === 'image'"
                    (error)="file.previewUrl = 'assets/images/image-error.svg'"
                    alt="Image preview"
                  />

                  <img
                    src="assets/images/pdf-icon.png"
                    class="image-preview"
                    *ngIf="file.type === 'pdf'"
                    alt="PDF document"
                  />

                  <div class="image-actions">
                    <span class="image-name">{{ file.name }}</span>
                    <button
                      class="remove-image-btn"
                      (click)="removeImage(i); $event.stopPropagation()"
                      type="button"
                    >
                      ×
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div
            class="error-message"
            *ngIf="
              fileControl.touched &&
              (fileControl.invalid || fileControl.hasError('invalidType'))
            "
          >
            Please upload a valid PDF file.
          </div>
        </div>
      </div>
    </div>
  </mat-dialog-content>

  <mat-dialog-actions class="form-actions">
    <button
      type="button"
      class="btn-cancel"
      (click)="onCancel()"
      [disabled]="isSubmitting"
    >
      Cancel
    </button>
    <button
      type="button"
      class="btn-save"
      (click)="onSave()"
      [disabled]="isSubmitting"
    >
      <span *ngIf="!isSubmitting">{{ isEditMode && (data?.initialData?.status === 'Rejected' || data?.initialData?.status === 'Declined') ? 'Resubmit' : 'Submit' }}</span>
      <span *ngIf="isSubmitting">Submitting...</span>
    </button>
  </mat-dialog-actions>
</main>
